import { FileNumberUtil } from './../../shared/file-number-util';
import { Router } from '@angular/router';
import { Bondsman } from './../bondsman';
import { Component, OnInit, Input } from '@angular/core';
import { HtmlUtil } from '../../shared/html-util';

@Component({
  selector: 'app-bond-forfeitures',
  templateUrl: './bond-forfeitures.component.html',
  styleUrls: ['./../../case-view/civil/civil-case-view.component.less', './bond-forfeitures.component.less']
})
export class BondForfeituresComponent implements OnInit {
  @Input() isRequestForForeituresInFlight: boolean
  @Input() bondsman: Bondsman;
  ALL = 'ALL';
  selectedCounty = this.ALL;
  selectedJudgment = this.ALL;
  selectedLicenseType = this.ALL;

  constructor(
    private router: Router) {
  }
  ngOnInit() {
  }
  getCountyList(bondsman: Bondsman): string[] {
    let countyList: string[] = [this.ALL];
    let forfeitureList: string[] = bondsman.getBondForfeitureList(bondsman, this.ALL, this.ALL, this.ALL);

    for (let forfeiture of forfeitureList) {
        let county: string = bondsman.getForfeitureCounty(forfeiture);
        if (this.isInListAlready(county, countyList) === false) {
          countyList.push(county);
        }
    }
    return countyList;
  }
  getJudgmentList(bondsman: Bondsman): string[] {
    let judgmentList: string[] = [this.ALL];
    let forfeitureList: string[] = bondsman.getBondForfeitureList(bondsman, this.ALL, this.ALL, this.ALL);

    for (let forfeiture of forfeitureList) {
        let county: string = bondsman.getForfeitureJudgment(forfeiture);
        if (this.isInListAlready(county, judgmentList) === false) {
          judgmentList.push(county);
        }
    }
    return judgmentList;
  }
  getLicenseTypeListForFilter(bondsman: Bondsman): string[] {
    let licenseTypeList: string[] = [this.ALL];
    let forfeitureList: string[] = bondsman.getBondForfeitureList(bondsman, this.ALL, this.ALL, this.ALL);

    for (let forfeiture of forfeitureList) {
        let county: string = bondsman.getForfeitureLicenseType(forfeiture);
        if (this.isInListAlready(county, licenseTypeList) === false) {
          licenseTypeList.push(county);
        }
    }
    return licenseTypeList;
  }
  isInListAlready(county: string, countyList: string[]): boolean {
    for (let aCounty of countyList) {
      if (aCounty === county) {
        return true;
      }
    }
   return false;
  }
  onViewCaseSelected(bondsman: Bondsman, forfeiture: any): void {
    this.router.navigate(
      [{
        outlets: {
          view: [ 'details',
                  'CIVIL',
                  bondsman.getForfeitureCounty(forfeiture),
                  FileNumberUtil.normalizeCaseNumberWithoutCentury(bondsman.getForfeitureCaseNumber(forfeiture))]
        }
      }]);
  }
  selectedCountyFilter(county: string) {
    console.log('county filter selected: ' + county);
    this.selectedCounty = county;
  }
  getSelectedCounty(): string {
    return this.selectedCounty;
  }
  getSelectedJudgment(): string {
    return this.selectedJudgment;
  }
  getSelectedLicenseType(): string {
    return this.selectedLicenseType;
  }
  selectedJudgmentFilter(judgment: string) {
    console.log('judgment filter selected ' + judgment);
    this.selectedJudgment = judgment;
  }
  selectedLicenseTypeFilter(licenseType: string) {
    console.log('license type filter selected ' + licenseType);
    this.selectedLicenseType = licenseType;
  }
  public popOverHandler(type: string) {
    HtmlUtil.popOverHandler(type);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bond-forfeitures/bond-forfeitures.component.ts